<template>
	<div class="form">
		<form @submit.prevent="submitRequest()" v-if="!success">

			<div class="form__group">
				<div>
					<label for="firstName">First Name <span class="required">*</span></label><input type="text" name="firstName" id="firstName" v-model="$v.request.fields.FNAME.$model" autofocus>
					<label for="firstName" class="error" v-if="$v.request.fields.FNAME.$dirty && $v.request.fields.FNAME.$invalid">First Name is a required field.</label>
				</div>
				<div>
					<label for="lastName">Last Name <span class="required">*</span></label><input type="text" name="lastName" id="lastName" v-model="$v.request.fields.LNAME.$model">
					<label for="lastName" class="error" v-if="$v.request.fields.LNAME.$dirty && $v.request.fields.LNAME.$invalid">Last Name is a required field.</label>
				</div>
			</div>

			<label for="email">Email <span class="required">*</span></label><input type="text" name="email" id="email" v-model="$v.request.email_address.$model">
			<label for="email" class="error" v-if="$v.request.email_address.$dirty && $v.request.email_address.$invalid">A valid email address is a required.</label>

			<label for="school">School / Organization <span class="required">*</span></label><input type="text" name="school" id="school" v-model="request.fields.MMSCHOOL">
			<label for="district">District / Other <span class="required">*</span></label><input type="text" name="district" id="district" v-model="request.fields.MMDISTRICT">

			<label for="state">Position / Title <span class="required">*</span></label>
			<select name="position" id="position" v-model="request.fields.POSITION">
				<option value="">Select a position / title</option>
				<option value="Teacher">Teacher</option>
				<option value="Coach/Teacher Support">Coach/Teacher Support</option>
				<option value="Principal/Assistant Principal">Principal/Assistant Principal</option>
				<option value="District Leadership">District Leadership</option>
				<option value="Technology">Technology</option>
			</select>

			<div class="form__group">
				<div>
					<label for="city">City <span class="required">*</span></label><input type="text" name="city" id="city" v-model="request.fields.MMERGE5">
				</div>
				<div>
					<label for="state">State <span class="required">*</span></label>
					<USStatesSelect name="state" id="state" v-model="request.fields.MMERGE6" :abbrev="false" />
				</div>
			</div>

			<div class="form__submit">
				<btn><input type="submit" :value="(loading) ? 'Sending...' : 'Submit'" :disabled="loading || $v.request.$invalid"></btn>
			</div>

		</form>
		<div class="thankyou" v-else>
			<h2>Thank you</h2>
			<p>You have been added to our mailing list.</p>
		</div>
	</div>

</template>

<script>

	import axios from 'axios'
	import { validationMixin } from 'vuelidate'
	import { required, email } from 'vuelidate/lib/validators'
	import USStatesSelect from '@/components/USStatesSelect'

	export default {
		mixins: [validationMixin],
		name: 'subscribeForm',
		components: { USStatesSelect },
		data () {
			return {
				success: false,
				loading: false,
				request: {
					email_address: null,
					fields: {
						FNAME: null,
						LNAME: null,
						MMSCHOOL: null,
						MMDISTRICT: null,
						POSITION: '',
						MMERGE5: null,
						MMERGE6: null
					}
				}
			}
		},

		methods: {
			submitRequest () {
				this.loading = true
				axios.post('/api/v1/subscribe', this.request)
					.then(() => {
						this.success = true
						this.$emit('success')
					})
					.catch(() => {
						alert('There was an error while processing your contact request. Please refresh the page and try again.')
					})
					.then(() => {
						this.loading = false
					})
			}
		},

		validations: {
			request: {
				email_address: { required, email },
				fields: {
					FNAME: { required },
					LNAME: { required },
					MMSCHOOL: { required },
					MMDISTRICT: { required },
					POSITION: { required },
					MMERGE5: { required },
					MMERGE6: { required }
				}
			}
		}
	}

</script>

<style lang="scss">

	@import "form-styles";

	.form {
		@include form-styles;
	}

</style>



// WEBPACK FOOTER //
// src/components/SubscribeForm.vue